// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const StatusListingRoot = styled.div`
  position: fixed;
  right: 1.5rem;
  bottom: 3rem;
  z-index: 2;
`;
